import type { OperationProgressModel } from '../../../shared/ui/progress';

const FailureDetail = 'Review the project setup details before retrying parameter setup.';

export function buildMappingRepairFailureProgress(
  message: string,
  evidence: OperationProgressModel | null
): OperationProgressModel {
  return {
    ...evidence,
    title: 'Applying mapping setup',
    message,
    detail: evidence?.detail ?? FailureDetail,
    status: 'error',
    percent: evidence?.percent ?? null,
    error: message,
    locked: false,
  };
}
